import { render, staticRenderFns } from "./sales_dashboard.vue?vue&type=template&id=48e73d19&scoped=true&"
import script from "./sales_dashboard.vue?vue&type=script&lang=js&"
export * from "./sales_dashboard.vue?vue&type=script&lang=js&"
import style0 from "./sales_dashboard.vue?vue&type=style&index=0&id=48e73d19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e73d19",
  null
  
)

export default component.exports